import { createSelector } from 'redux-bundler';

import PlatformActivity from '../models/platform_activity';

const STALE_AFTER = 60_000;
const PERMISSION_NAME = 'admin.platform.activity';

const initialData = {
  loadedAt: null,
  loading: false,
  item: null,
  forbidden: false,
};

export default {
  name: 'platformActivities',

  getReducer: () => (state = initialData, { type, payload }) => {
    if (type === 'FETCH_PLATFORM_ACTIVITY_START') {
      return { ...state, loading: true };
    }
    if (type === 'FETCH_PLATFORM_ACTIVITY_SUCCESS') {
      return {
        ...state,
        loading: false,
        item: payload.result,
        loadedAt: Date.now(),
        forbidden: false,
      };
    }
    if (type === 'FETCH_PLATFORM_ACTIVITY_FORBIDDEN') {
      return {
        ...state,
        loading: false,
        forbidden: true,
        loadedAt: Date.now(),
      };
    }
    if (type === 'FETCH_PLATFORM_ACTIVITY_ERROR') {
      return { ...state, loading: false, loadedAt: Date.now() };
    }
    return state;
  },

  doFetchPlatformActivity: () => async ({ dispatch }) => {
    dispatch({ type: 'FETCH_PLATFORM_ACTIVITY_START' });
    try {
      const response = await PlatformActivity.all();
      const item = response.data && response.data[0] ? response.data[0] : null;
      dispatch({
        type: 'FETCH_PLATFORM_ACTIVITY_SUCCESS',
        payload: { result: item },
      });
    } catch (err) {
      const status =
        (err && err.response && err.response.status) || (err && err.status);
      if (status === 403) {
        dispatch({ type: 'FETCH_PLATFORM_ACTIVITY_FORBIDDEN' });
      } else {
        dispatch({ type: 'FETCH_PLATFORM_ACTIVITY_ERROR' });
      }
    }
  },

  reactShouldFetchPlatformActivity: createSelector(
    'selectAuthenticatedUser',
    'selectPlatformActivities',
    'selectPlatformActivitiesAreStale',
    (user, state, stale) => {
      if (!user || !user.isAuthorized(PERMISSION_NAME)) return false;
      if (state.forbidden) return false;
      if (state.loading) return false;
      if (!stale) return false;
      return { actionCreator: 'doFetchPlatformActivity' };
    },
  ),

  selectPlatformActivities: state => state.platformActivities,
  selectPlatformActivityItem: state => state.platformActivities.item,
  selectPlatformActivitiesAreStale: createSelector(
    'selectPlatformActivities',
    'selectAppTime',
    (s, appTime) => {
      if (!s.loadedAt) return true;
      return appTime - s.loadedAt > STALE_AFTER;
    },
  ),
};
